import { render, staticRenderFns } from "./creatPerformance.vue?vue&type=template&id=67e59e7b&scoped=true"
import script from "./creatPerformance.vue?vue&type=script&lang=js"
export * from "./creatPerformance.vue?vue&type=script&lang=js"
import style0 from "./creatPerformance.vue?vue&type=style&index=0&id=67e59e7b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e59e7b",
  null
  
)

export default component.exports